import _objectWithoutProperties from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';
import { viewGet, VIEW_ACTION_APPEND } from '../../../redux/actions/Entity/View';
import EntityMapperContext from '../../../Context/EntityMapperContext';

var View = /*#__PURE__*/function (_Component) {
  _inherits(View, _Component);

  function View(props) {
    var _this;

    _classCallCheck(this, View);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(View).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onLoadMore", function (action) {
      var _this$props = _this.props,
          view = _this$props.view,
          id = _this$props.id,
          display = _this$props.display,
          args = _this$props.args,
          filters = _this$props.filters;
      var page = view.getIn(['pager', 'current_page']);

      _this.props.dispatch(viewGet(id, display, page + 1, args, filters, VIEW_ACTION_APPEND, false));

      _this.setState({
        loading: true,
        loadingStartedAt: new Date()
      });
    });

    _this.timeouts = [];
    _this.state = {
      loading: false,
      loadingStartedAt: 0,
      entities: props.view ? props.view.get('entities', List()) : List(),
      header: props.view ? props.view.get('header', List()) : List(),
      footer: props.view ? props.view.get('footer', List()) : List(),
      empty: props.view ? props.view.get('empty', List()) : List()
    };
    return _this;
  }

  _createClass(View, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          display = _this$props2.display,
          page = _this$props2.page,
          args = _this$props2.args,
          filters = _this$props2.filters,
          dispatch = _this$props2.dispatch;
      dispatch(viewGet(id, display, page, args, filters));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          display = _this$props3.display,
          page = _this$props3.page,
          view = _this$props3.view,
          args = _this$props3.args,
          filters = _this$props3.filters,
          currentLanguage = _this$props3.currentLanguage,
          dispatch = _this$props3.dispatch;
      var loadingStartedAt = this.state.loadingStartedAt;
      var shouldUpdate = prevProps.id !== id || prevProps.display !== display || prevProps.page !== page || prevProps.args.length !== args.length || prevProps.args[0] !== args[0] || JSON.stringify(prevProps.filters) !== JSON.stringify(filters) || prevProps.currentLanguage !== currentLanguage;

      if (shouldUpdate) {
        dispatch(viewGet(id, display, page, args, filters));
      }

      if (prevProps.view && view && prevProps.view !== view) {
        // Our view got updated, so merge it to our internal state.
        // Update the view with a timeout to show the user at least an X amount
        // of seconds of the loading animation to indicate a loading process.
        // NOTE: Only do the above when the actual request took longer than the
        // X amount of seconds. If not, we want to calculate the minimum amount
        // of time to wait for the animation to have been shown once.
        var minimumTimeout = 1666;
        var loadingTime = new Date() - loadingStartedAt;
        var loadingTimeout = loadingTime >= minimumTimeout ? 0 : minimumTimeout - loadingTime;
        this.timeouts.push(setTimeout(function () {
          _this2.setState({
            loading: false,
            entities: view.get('entities', List()),
            header: view.get('header', List()),
            footer: view.get('footer', List()),
            empty: view.get('empty', List())
          });
        }, loadingTimeout));
      } else if (!prevProps.view && view) {
        // This is our initial call where we receive our view for the first time.
        this.setState({
          loading: false,
          entities: view.get('entities', List()),
          header: view.get('header', List()),
          footer: view.get('footer', List()),
          empty: view.get('empty', List())
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      for (var i = 0, len = this.timeouts.length; i < len; i++) {
        clearTimeout(this.timeouts[i]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          view = _this$props4.view,
          id = _this$props4.id,
          display = _this$props4.display,
          args = _this$props4.args,
          filters = _this$props4.filters,
          className = _this$props4.className,
          props = _objectWithoutProperties(_this$props4, ["view", "id", "display", "args", "filters", "className"]);

      var _this$state = this.state,
          loading = _this$state.loading,
          entities = _this$state.entities,
          header = _this$state.header,
          footer = _this$state.footer,
          empty = _this$state.empty;

      if (!view) {
        return null;
      }

      var viewMode = view.get('viewMode');
      var views_block_id = "views_block__".concat(id, "_").concat(display);
      var pager = view.get('pager', Map());
      var classes = classNames('View', className);
      return /*#__PURE__*/React.createElement(EntityMapperContext.Consumer, null, function (entityTypesMapper) {
        var viewMappers = entityTypesMapper.view;
        var ViewComponent = viewMappers[views_block_id];

        if (ViewComponent) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes,
            "view-block-id": views_block_id
          }, /*#__PURE__*/React.createElement(ViewComponent, _extends({}, props, {
            pager: pager,
            entities: entities,
            header: header,
            footer: footer,
            empty: empty,
            viewId: id,
            display: display,
            viewMode: viewMode,
            onLoadMore: _this3.onLoadMore,
            loading: loading,
            args: args,
            filters: filters
          })));
        }

        return /*#__PURE__*/React.createElement("div", null, "No view found: ", views_block_id);
      });
    }
  }]);

  return View;
}(Component);

View.defaultProps = {
  page: 0,
  args: [],
  filters: {}
};
View.propTypes = {
  page: PropTypes.number,
  args: PropTypes.array,
  filters: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    args: ownProps.args,
    filters: ownProps.filters,
    display: ownProps.display,
    view: state.getIn(['view', ownProps.id, ownProps.display]),
    currentLanguage: state.getIn(['ui', 'language'])
  };
}

export default connect(mapStateToProps)(View);